import request from '@/utils/request'

// 查询列表-订单满足率
export function apiInvOrderSatisfyRateList (query) {
  return request({
    url: '/inv/invOrderSatisfyRate/list',
    method: 'get',
    params: query
  })
}

// 修改-订单满足率
export function apiUpdateOrderSatisfyRate (data) {
  return request({
    url: '/inv/invOrderSatisfyRate',
    method: 'put',
    data: data
  })
}

// 新增-订单满足率
export function apiAddOrderSatisfyRate (data) {
  return request({
    url: '/inv/invOrderSatisfyRate',
    method: 'post',
    data: data
  })
}

// 批量编辑快递类产品
export function apiInvDeliveryProductsBatchEdit (data) {
  return request({
    url: '/inv/invDeliveryProducts/batchEdit',
    method: 'post',
    data: data
  })
}

// 批量编辑订单满足率
export function apiInvOrderSatisfyRateBatchEdit (data) {
  return request({
    url: '/inv/invOrderSatisfyRate/batchEdit',
    method: 'post',
    data: data
  })
}

// 查询列表-安全库存水位
export function apiInvSafetyStockLevelList (query) {
  return request({
    url: '/inv/invSafetyStockLevel/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiInvOrderSatisfyRateNewExport (data) {
  return request({
    url: '/inv/invOrderSatisfyRate/v2/export',
    method: 'post',
    data: data
  })
}

// 修改-安全库存水位
export function apiUpdateInvSafetyStockLevel (data) {
  return request({
    url: '/inv/invSafetyStockLevel ',
    method: 'put',
    data: data
  })
}

// 新增-安全库存水位
export function apiAddInvSafetyStockLevel (data) {
  return request({
    url: '/inv/invSafetyStockLevel',
    method: 'post',
    data: data
  })
}

// 订单满足率历史记录查询
export function apiInvOrderSatisfyRateHisList (query) {
  return request({
    url: '/inv/invOrderSatisfyRateHis/list',
    method: 'get',
    params: query
  })
}

// 查询快递类产品维护
export function apiInvDeliveryProductsList (query) {
  return request({
    url: '/inv/invDeliveryProducts/list',
    method: 'get',
    params: query
  })
}

// 新增快递类产品维护
export function apiInvDeliveryProductsAdd (data) {
  return request({
    url: '/inv/invDeliveryProducts',
    method: 'post',
    data: data
  })
}

// 修改-快递类产品维护
export function apiInvDeliveryProductsEdit (data) {
  return request({
    url: '/inv/invDeliveryProducts',
    method: 'put',
    data: data
  })
}
